import React, { useState, useMemo } from 'react';

const SHOW = 'SHOW';
const SEARCH = 'SEARCH';

const filter = (pattern, array = []) => {
  if (pattern === null || pattern.length === 0) return array.slice(0, 20);

  const re = new RegExp(pattern, 'ig');

  const notInArray = (airport, array) => array.findIndex(({ iataCode }) => iataCode === airport.iataCode) === -1;

  const filteredByCode = array.filter(airport => re.test(airport.iataCode));

  const filteredByCity = array.filter(airport =>
    (re.test(airport.cityNameAr) || re.test(airport.cityNameEn))
    && notInArray(airport, filteredByCode)
  );
  const filteredByTitle = array.filter(airport =>
    (re.test(airport.nameAr) || re.test(airport.nameEn))
    && notInArray(airport, [...filteredByCode, ...filteredByCity])
  );

  const filteredByAll = [
    ...filteredByCode,
    ...filteredByCity,
    ...filteredByTitle
  ];

  return filteredByAll;
};

const Airport = ({ airport = {}, onClick, tabIndex, onFocus, placeholder }) => (
  <div className="airport" onClick={onClick} tabIndex={tabIndex} onFocus={onFocus}>
    <div className="code">{airport.iataCode || ''}</div>
    <div className="title">{airport.nameAr || placeholder}</div>
    <div className="city">{airport.cityNameAr}</div>
  </div>
);

const AirportPicker = ({ value, airports, onChange, placeholder }) => {
  const [data, setData] = useState({ query: '', mode: SHOW });

  const switchSearch = () => setData({ ...data, mode: SEARCH });
  const switchShow = () => setData({ ...data, mode: SHOW });

  const select = (airport) => {
    switchShow();
    onChange(airport);
  };

  const filteredAirports = useMemo(() => filter(data.query, airports), [data.query, airports]);

  if (data.mode === SEARCH) {
    return (
      <div className="airport" tabIndex={0} onBlur={() => setTimeout(switchShow, 300)} style={{ alignSelf: 'flex-start' }}>
        <div className="search-input">
          <input
            value={data.query}
            type="search"
            autoFocus={true}
            onChange={({ target: { value } }) => setData({ ...data, query: value })}
            onKeyDown={({ key }) => { if (key === 'Enter') select(filteredAirports[0]); }}
          />
          <i className="fas fa-search"></i>
        </div>

        <div className="airport-list">
          {filteredAirports.map((airport) => <Airport key={airport.iataCode} airport={airport} onClick={() => select(airport)} />)}
        </div>
      </div>
    );
  }

  return (
    <Airport
      airport={value || {}}
      onClick={switchSearch}
      tabIndex={0}
      onFocus={switchSearch}
      placeholder={placeholder}
    />
  );
};

export default AirportPicker;